'use strict';

var AuthLevels = require('./AuthLevels');

function AuthService ($http, $q, $rootScope, sbAuth, IdentityService, RoutingUtil, Utils, MetricsService) {

  /**
   * Called when the module is loaded
   */
  this.init = function () {
    // init KPI service and send initial events
    MetricsService.init()

    $rootScope.$on('auth:refreshError', function () {
      IdentityService.clearAuth(); // clear auth related caches on error
      RoutingUtil.redirectToLogout();
    });
  };

  /**
   * Check to see if the user is authorized to view the requested state.
   *
   * This is used when configuring a $state to control access to that state, so we return a
   * promise because that is what $stateProvider 'resolve' expects.
   */
  this.authorizeState = function (params) {

    var user = IdentityService.getUser();
    var toState = $rootScope.toState;
    var access = toState.data.access;
    var siteId = params.siteId;

    // TODO --- RENABLE THIS WHEN PERMISSIONS ARE READY
    // if (access.length && siteId) {
    //   return getUserSitePermissions(siteId)
    //   .then(function (permissions) {

    //     // ALL access permissions must be present
    //     var allowed = !_.any(access, function (a) {
    //       return permissions.indexOf(a) === -1;
    //     });

    //     if (allowed) {
    //       return user;
    //     } else {
    //       return $q.reject(Errors.NOT_AUTHORIZED);
    //     }
    //   });
    // } else {
    //   return $q.when(user);
    // }

    return $q.when(user); // TODO change to $q.resolve
  };


  //////////////////////////////////////////////////////////////////////////////
  // Getters
  //////////////////////////////////////////////////////////////////////////////

  /**
   * @returns {promise} request to exchange refreshToken and sets the new one
   */
  this.getNewRefreshToken = function () {
    return sbAuth.refreshToken();
  };

  /**
   * @return {Boolean} true if authenticated
   */
  this.isAuthenticated = function () {
    var user = IdentityService.getUser();
    var fbUrl = IdentityService.getFirebaseUri();
    var fbToken = IdentityService.getFirebaseToken();

    // TODO: Need to review behavior for "anon" user, mismatch between AuthService and IdentityService
    var isAnonUser = user && (!user.email || user.group === 'anon');
    var isAuthenticated = user && !isAnonUser && fbUrl && fbToken && sbAuth.isAuthenticated();

    return isAuthenticated;
  };

  /**
   * Compares user authorization level with a given min access level and returns true if the user
   * is authorized.
   *
   * @return {Boolean} true if authorized
   */
  this.isAuthorized = function (minLevel) {
    var authorized = false;

    if (this.isAuthenticated()) {
      var level = IdentityService.getUserLevel();
      return level >= minLevel;
    }

    return authorized;
  };

  this.isAdmin = function () {
    return this.isAuthorized(AuthLevels.ADMIN);
  };
}

AuthService.$inject = ['$http', '$q', '$rootScope', 'sbAuth', 'IdentityService', 'RoutingUtil', 'Utils', 'MetricsService'];
module.exports = AuthService;



// WEBPACK FOOTER //
// ./src/common/auth/AuthService.js